import * as React from 'react';
import { Bem, addClass } from '../../utils/css.js';
import { warnOnce } from '../../utils/common.js';
import { useId } from '../../utils/hooks/useId.js';
import './HeaderMenuItem.scss.js';
import { renderIcon } from './headerUtils.js';

const bem = Bem.create("vai-header-menu-item");
const HeaderMenuItem = (props) => {
  const { component = "div", children, onClick, startIcon, iconColor, iconName, htmlId, dataTa, className, innerRef, disabled, ...rest } = props;
  const id = useId(htmlId, ["header dropdown item"]);
  const classNames = addClass(bem.block((props.iconName || startIcon) && "with-icon", disabled && "disabled"), className);
  const renderStartIcon = (bemObject) => {
    if (startIcon) {
      return /* @__PURE__ */ React.createElement("span", {
        className: bemObject.element("icon-start")()
      }, startIcon);
    }
    if (iconName) {
      return renderIcon(id, bemObject, iconName, iconColor);
    }
    return null;
  };
  const Component = component;
  React.useEffect(() => {
    if (iconName) {
      warnOnce(`The iconName and iconColor prop is deprecated. Use startIcon instead.`);
    }
  }, [iconColor, iconName]);
  return /* @__PURE__ */ React.createElement(Component, {
    ref: innerRef,
    id: id.toString(),
    "data-ta": dataTa,
    className: classNames,
    onClick,
    role: "menuitem",
    tabIndex: disabled ? -1 : 0,
    ...rest
  }, renderStartIcon(bem), /* @__PURE__ */ React.createElement("span", {
    className: bem.element("children")()
  }, children));
};

export { HeaderMenuItem };
